import './NotFoundPage.css'
const NotFoundPage = () => {
    return (
        <div className="not-found-container">
            <h1 className="not-found-code">404</h1>
            <h2>The page you are looking for does not exist.</h2>
            <p>The page you are looking for may have been moved or removed altogether.</p>
        </div>
    );
};                                                                                                                          

export default NotFoundPage;
